//----- AUTOGENERATED (changes will be overwritten) -------
import * as $runtime from "../runtime.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign$dGeneric from "../Foreign.Generic/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
const accountIdIsSymbol = {reflectSymbol: () => "accountId"};
const emailIsSymbol = {reflectSymbol: () => "email"};
const phoneIsSymbol = {reflectSymbol: () => "phone"};
const showMaybe = {
  show: v => {
    if (v.tag === "Just") { return "(Just " + Data$dShow.showStringImpl(v._1) + ")"; }
    if (v.tag === "Nothing") { return "Nothing"; }
    $runtime.fail();
  }
};
const WithdrawMarketingConsentRequestIsSymbol = {reflectSymbol: () => "WithdrawMarketingConsentRequest"};
const decodeMaybe = /* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeString1);
const encodeWithOptionsOther = {
  encodeWithOptions: v => v2 => {
    if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
    if (v2.tag === "Just") { return v2._1; }
    $runtime.fail();
  }
};
const decodeWithOptionsOther = {decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.readString)};
const WithdrawMarketingConsentRequest = x => x;
const eqWithdrawMarketingConsen = {
  eq: x => y => x.accountId === y.accountId && (() => {
    if (x.email.tag === "Nothing") { return y.email.tag === "Nothing"; }
    if (x.email.tag === "Just") {
      if (y.email.tag === "Just") { return x.email._1 === y.email._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.phone.tag === "Nothing") { return y.phone.tag === "Nothing"; }
    if (x.phone.tag === "Just") {
      if (y.phone.tag === "Just") { return x.phone._1 === y.phone._1; }
      return false;
    }
    return false;
  })()
};
const rpcMethodNameWithdrawMarketingConsentRequest = {rpcMethodName: v => "WithdrawMarketingConsentRequest"};
const newtypeWithdrawMarketingConsentRequest = {Coercible0: () => {}};
const hasFieldWithdrawMarketingConsentRequest = dictHasField => dictHasField;
const genericWithdrawMarketingConsentRequest = {to: x => x, from: x => x};
const showWithdrawMarketingConsentRequest = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => ["{ accountId: " + Data$dShow.showIntImpl(v.accountId) + ", email: " + showMaybe.show(v.email) + ", phone: " + showMaybe.show(v.phone) + " " + "}"]
    })(WithdrawMarketingConsentRequestIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeWithdrawMarketingConsentRequest = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(accountIdIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordCons(emailIsSymbol)(decodeMaybe)(Unscramble.decodeRecordCons(phoneIsSymbol)(decodeMaybe)(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
  }
))();
const encodingOpts = {...Foreign$dGeneric$dClass.defaultOptions, unwrapSingleConstructors: true, unwrapSingleRecordArguments: true};
const encodeWithdrawMarketingConsentRequest = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.genericEncodeConstructor(WithdrawMarketingConsentRequestIsSymbol)((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(phoneIsSymbol)(encodeWithOptionsOther))(emailIsSymbol)(encodeWithOptionsOther))(accountIdIsSymbol)({
        encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })()).encodeOpts(encodingOpts)
  }
))();
const decodeWithdrawMarketingConsentRequest = {
  decode: /* #__PURE__ */ Foreign$dGeneric.genericDecode(genericWithdrawMarketingConsentRequest)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(WithdrawMarketingConsentRequestIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(phoneIsSymbol)(decodeWithOptionsOther)())(emailIsSymbol)(decodeWithOptionsOther)())(accountIdIsSymbol)({
    decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode
  })())))(Foreign$dGeneric$dClass.genericCountArgsArgument))(encodingOpts)
};
export {
  WithdrawMarketingConsentRequest,
  WithdrawMarketingConsentRequestIsSymbol,
  accountIdIsSymbol,
  decodeMaybe,
  decodeWithOptionsOther,
  decodeWithdrawMarketingConsentRequest,
  emailIsSymbol,
  encodeWithOptionsOther,
  encodeWithdrawMarketingConsentRequest,
  encodingOpts,
  eqWithdrawMarketingConsen,
  genericWithdrawMarketingConsentRequest,
  hasFieldWithdrawMarketingConsentRequest,
  newtypeWithdrawMarketingConsentRequest,
  phoneIsSymbol,
  rpcMethodNameWithdrawMarketingConsentRequest,
  showMaybe,
  showWithdrawMarketingConsentRequest,
  unscrambleDecodeWithdrawMarketingConsentRequest
};
